var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$parent.$parent.rerender)?_c('div',{staticClass:"row myrow content-mb-42"},[_c('div',{staticClass:"col-xs-12 mycol content-mb-14",class:{
      'has-error': _vm.$parent.$parent.checkErrorField(
        'PROJECTS',
        'LOGIC',
        'UF_LIST_PRIORITY_PRODUCTS_FORMED_MVK_ID'
      )
    }},[_vm._m(0),_vm._v(" "),_c('Multiselect',{staticClass:"i-main-style i-wid-50 stl-bs_bb multiselect-filter-project-register multiselect-multiline",attrs:{"label":"LABEL","limit":200,"limitText":_vm.filterItemText,"track-by":"ID","disabled":_vm.$parent.$parent.projectDisabled,"options":_vm.filterMVKList,"multiple":true,"placeholder":""},model:{value:(
        _vm.$parent.project.SETTING_TABLE.allData
          .UF_LIST_PRIORITY_PRODUCTS_FORMED_MVK_ID
      ),callback:function ($$v) {_vm.$set(_vm.$parent.project.SETTING_TABLE.allData
          , "UF_LIST_PRIORITY_PRODUCTS_FORMED_MVK_ID", $$v)},expression:"\n        $parent.project.SETTING_TABLE.allData\n          .UF_LIST_PRIORITY_PRODUCTS_FORMED_MVK_ID\n      "}}),_vm._v(" "),_c('div',{staticClass:"error-text"},[_vm._v("\n      "+_vm._s(_vm.$parent.$parent.checkErrorText(
          "PROJECTS",
          "LOGIC",
          "UF_LIST_PRIORITY_PRODUCTS_FORMED_MVK_ID"
        ))+"\n    ")])],1)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"content-s-2-label"},[_c('label',[_vm._v("Выбор приоритетной продукции:")])])
}]

export { render, staticRenderFns }